import { createContext, useContext } from 'react';

import { isEmbedded } from '../store/embedded';

const EmbeddedContext = createContext({
  isEmbedded,
});

export const EmbeddedProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <EmbeddedContext.Provider value={{ isEmbedded }}>
      {children}
    </EmbeddedContext.Provider>
  );
};

export const useEmbedded = () => {
  return useContext(EmbeddedContext);
};
